import { StyledCol } from '../ContainerLookupStyles';

export const LabelCol = ({ label, span, children }: { label?: String; span?: number; children?: any }) => {
  span = span || 7;
  return (
    <StyledCol span={span} color={'secondary'}>
      {label || children}
    </StyledCol>
  );
};
